/**
 * @author：
 * @update：
 * @description：
 **/
import {esList,esReset} from '../../api/url'
import CusPagination from '@/components/cusPagination.vue';
export default {
    components: {
        CusPagination,
    },
    data() {
        return {
            loading:false,
            operationTime:[],//操作时间
            operationMan:'',//操作人
            tableData:[],
            isShow:false,//是否显示重置
            page:1,
            size:20,
            count:0,
        };
    },
    // 自定义方法
    methods: {
        getList(){
            this.loading = true;
            let time = '';
            if(this.operationTime.length>0){
                time = this.operationTime.join(',')
            }
            let data = {
                createdDate:time,
                name:this.operationMan,
                pageNumber:this.page,
                pageSize:this.size
            }
            this.$ajax.get(esList,data).then(res=>{
                console.log(res);
                if(res.status===200){
                    this.count = res.data.total;
                    this.tableData = res.data.rows;
                    this.loading = false;
                    if(res.data.rows.length==0){
                        this.isShow=true;
                    }else{
                        if(this.page===1&&res.data.rows[0].createdDate.split(' ')[0]!=this.getNowFormatDate()){
                            this.isShow=true;
                        }
                    }
                }

            },err=>{
                console.log(err);
                this.loading = false;
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
        getNowFormatDate () {
            let date = new Date();
            let seperator1 = "-";
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            let currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },
        resetBtn(){
            this.$confirm('注：重置ES缓存资源是将搜索处现有的ES资源先删除，再重新拉取数据库中的ES资源，此功能可以解决搜索页显示非出售中商品的问题，重置ES缓存资源时间大概10-30分钟。请谨慎操作此功能。', '是否确认重置ES缓存资源？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$ajax.get(esReset).then(res=>{
                    console.log(res);
                    this.$message({
                        showClose:true,
                        message:'重置任务已提交',
                        type:'success',
                        center:true,
                        duration:3000
                    });
                    this.page = 1;
                    this.getList();
                },err=>{
                    console.log(err);
                    this.$message({
                        showClose:true,
                        message:err.data,
                        type:'error',
                        center:true,
                        duration:3000
                    })
                })
            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: '已取消删除'
                // });
            });

        },
        //审核员
        returnUserInfo(userInfo){
            let name = '--';
            if(userInfo.type=="ENTERPRISE"){
                name = userInfo.legalPerson;
            }else{
                if(userInfo.state=="CERTIFIED"){
                    name = userInfo.realName
                }else{
                    name = userInfo.nickname
                }
            }
            return name
        },
    },
    // 数据观察监听
    watch: {
        page(newData,oldData){
            this.getList();
        },
        size(newData,oldData){
            this.page = 1;
            this.getList();
        },
    },
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {

    },
    // 组件挂载完成之前
    beforeMount() {
        this.getList()
    },
    // 组件挂载完成
    mounted() {

    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
